module.exports = __webpack_public_path__ + "img/etousoft.82a3c378.png";